module.exports = __webpack_public_path__ + "img/logo.215a5d8c.png";